// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#app {
    width: 100%;
    background-color: #e9e9e9;
}
.PowerBIEmbed {
    flex-grow: 1;
    height: 100%;
}
.PowerBIEmbed iframe {
    border: none;
}
/* Styles added for center alignment TablePagination child components */
.MuiTablePagination-root .MuiTablePagination-select {
    padding: 0;
}
.MuiTablePagination-root p {
    margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/ui/index.css"],"names":[],"mappings":"AAAA;;;IAGI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA,uEAAuE;AACvE;IACI,UAAU;AACd;AACA;IACI,SAAS;AACb","sourcesContent":["html,\nbody,\n#app {\n    width: 100%;\n    background-color: #e9e9e9;\n}\n.PowerBIEmbed {\n    flex-grow: 1;\n    height: 100%;\n}\n.PowerBIEmbed iframe {\n    border: none;\n}\n/* Styles added for center alignment TablePagination child components */\n.MuiTablePagination-root .MuiTablePagination-select {\n    padding: 0;\n}\n.MuiTablePagination-root p {\n    margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
